import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Offer, OfferType, StatusDto} from "@/store/player/types";
import Sprite = Phaser.GameObjects.Sprite;
import Text = Phaser.GameObjects.Text;
import SpriteUtils from "@/utils/sprite-utils";
import PlayerStore from "@/store/player";

export class CampaignArtifactPanel extends VerticalStandardPanel {

    private lighting!: Sprite;

    private timeLabel!: Text;

    constructor(scene: Scene, canvas: HTMLCanvasElement, shopCallback: () => unknown) {
        super(scene, canvas, Tr('art.d'));
        this.background.setAlpha(0.01);

        let mainText = TextUtils.addTextByFamily(scene, Tr('art.d'),
            0, -174, '#ffc536', 21, 'normal', 380, Fonts.BENGALY_NORMAL);

        let descText = TextUtils.addTextByFamily(scene, Tr('art.d.d'),
            0, -124, '#ffebc4', 13, 'normal', 380, Fonts.BENGALY_NORMAL);


        let light = SpriteUtils.addSprite(this.scene!, 0, -50, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 4, 2);
        this.add(light);

        let creature1 = SpriteUtils.addSprite(this.scene!, -120, -50, 's_saga_sword',  's_dice_01', 0.8);
        let creature2 = SpriteUtils.addSprite(this.scene!, -40, -50, 's_forcety_sword', 's_butterfly_01', 0.8);
        let creature3 = SpriteUtils.addSprite(this.scene!, 40, -50, 's_saga_sword', 's_dice_10', 0.8);
        let creature4 = SpriteUtils.addSprite(this.scene!, 120, -50, 's_forcety_sword', 's_butterfly_30', 0.8);
        this.add([creature1, creature2, creature3, creature4]);

        let tillEndLabel = TextUtils.addTextAdvanced(scene, Tr('t.c.e'), 0, 32,
            '#716F6A', 10, 'normal', 350, 'center', 2, Fonts.ARIAL_MT);

        this.timeLabel = TextUtils.addTextByFamily(scene, Tr('ch.m.12.59'),
            0, 60, '#ffc536', 16, 'normal', 400, Fonts.ARIAL_MT);

        PlayerStore.fetchArtCampaignStatus().then((s: StatusDto) => {
            if (this.timeLabel && this.timeLabel.active) {
                this.timeLabel.setText(s.dates);
            }
        });

        let okButton = new SquareButton(this.scene, 0, 150, 0,
            Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('watch'), false);

        this.add(okButton);

        let self = this;
        okButton.setCallback(() => {
            if (this.isOnTop()) {
                self.close();
                shopCallback();
            }
        });

        this.add([tillEndLabel, mainText, descText, this.timeLabel]);
    }

    protected preInit(): void {
        this.lighting = SpriteUtils.addSprite(this.scene, 0, 0, Keys.OFFER_LIGHT_BACK, undefined, 4.6).setAlpha(0);
        this.add(this.lighting);

        this.scene!.tweens.add({
            targets: this.lighting,
            alpha: 1,
            duration: 500
        });

        this.scene!.tweens.add({
            targets: this.lighting,
            angle: 360,
            duration: 90000,
            loop: -1,
        });
    }

    protected preClose(): void {
        this.lighting.setVisible(false);
    }

}
